export default __webpack_public_path__ + "static/media/we.e41e1c1f.svg";